import { createFileRoute } from "@tanstack/react-router"
import { DocumentMMPPage } from "../../../../../components/WMS/Transfers/MMP/DocumentMMPPage.tsx"

export const Route = createFileRoute("/_layout/WMS/documents/doc-mmp/$docMmp")({
  component: DocumentMMPPage,
})
